export interface TvCategory {
  id: number;
  name: string;
  icon: string;
  color: string;
  bgColor: string;
  stationCount: number;
}

export interface TvRadio {
  id: number;
  name: string;
  frequency: string;
  category: string;
  image: string;
  isLive: boolean;
  currentProgram?: string;
  listeners: number;
}

export interface TvProgram {
  id: number;
  name: string;
  host: string;
  radioName: string;
  image: string;
  isLive: boolean;
  time: string;
  category: string;
}

export interface TvEvent {
  id: number;
  title: string;
  radioName: string;
  date: string;
  image: string;
  type: string;
}

export const tvCategories: TvCategory[] = [
  { id: 1, name: "Música", icon: "ri-music-line", color: "text-rose-500", bgColor: "bg-rose-500/10", stationCount: 18 },
  { id: 2, name: "Deportes", icon: "ri-football-line", color: "text-emerald-500", bgColor: "bg-emerald-500/10", stationCount: 8 },
  { id: 3, name: "Noticias", icon: "ri-newspaper-line", color: "text-sky-500", bgColor: "bg-sky-500/10", stationCount: 12 },
  { id: 4, name: "Cultural", icon: "ri-book-open-line", color: "text-violet-500", bgColor: "bg-violet-500/10", stationCount: 6 },
  { id: 5, name: "Religiosa", icon: "ri-heart-pulse-line", color: "text-amber-500", bgColor: "bg-amber-500/10", stationCount: 9 },
  { id: 6, name: "Entretenimiento", icon: "ri-movie-line", color: "text-orange-500", bgColor: "bg-orange-500/10", stationCount: 10 },
  { id: 7, name: "Regional", icon: "ri-map-pin-line", color: "text-teal-500", bgColor: "bg-teal-500/10", stationCount: 14 },
  { id: 8, name: "Hablada", icon: "ri-chat-3-line", color: "text-indigo-500", bgColor: "bg-indigo-500/10", stationCount: 5 },
];

export const tvLiveRadios: TvRadio[] = [
  {
    id: 1, name: "La Mexicana FM", frequency: "98.7 FM", category: "Regional",
    image: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20vibrant%20cover%20art%2C%20warm%20festive%20atmosphere%20with%20traditional%20instruments%2C%20orange%20and%20green%20colors%2C%20broadcast%20studio%20scene&width=400&height=300&seq=tv-radio-mexicana&orientation=landscape",
    isLive: true, currentProgram: "El Sabor del Mediodía", listeners: 4231,
  },
  {
    id: 2, name: "Rock Total Radio", frequency: "95.3 FM", category: "Música",
    image: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20concert%20atmosphere%20cover%20art%2C%20electric%20guitars%20on%20stage%20with%20dramatic%20red%20and%20blue%20lighting%2C%20energetic%20crowd&width=400&height=300&seq=tv-radio-rock&orientation=landscape",
    isLive: true, currentProgram: "Rock Total en Vivo", listeners: 2890,
  },
  {
    id: 3, name: "Radio Nueva Actitud", frequency: "102.5 FM", category: "Música",
    image: "https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20cover%20art%2C%20sleek%20studio%20with%20warm%20golden%20lighting%2C%20contemporary%20music%20broadcast%20aesthetic&width=400&height=300&seq=tv-radio-nueva&orientation=landscape",
    isLive: true, currentProgram: "Tardes de Actitud", listeners: 3150,
  },
  {
    id: 4, name: "Deportes Total Radio", frequency: "101.1 FM", category: "Deportes",
    image: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20dynamic%20cover%20art%2C%20soccer%20stadium%20background%20with%20blue%20and%20gold%20colors%2C%20sports%20commentary%20desk&width=400&height=300&seq=tv-radio-deportes&orientation=landscape",
    isLive: true, currentProgram: "Carrusel Deportivo", listeners: 5210,
  },
  {
    id: 5, name: "La Kalle 99.9", frequency: "99.9 FM", category: "Música",
    image: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20lively%20cover%20art%2C%20colorful%20neon%20lights%20and%20headphones%2C%20vibrant%20pink%20and%20coral%20studio%20atmosphere&width=400&height=300&seq=tv-radio-kalle&orientation=landscape",
    isLive: true, currentProgram: "Tardes de Pop", listeners: 2780,
  },
  {
    id: 6, name: "Banda Radio MX", frequency: "107.9 FM", category: "Regional",
    image: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20festive%20cover%20art%2C%20trumpets%20and%20traditional%20instruments%2C%20red%20white%20and%20green%20festive%20colors&width=400&height=300&seq=tv-radio-banda&orientation=landscape",
    isLive: true, currentProgram: "Tardes de Banda", listeners: 3650,
  },
  {
    id: 7, name: "Radio Fe y Esperanza", frequency: "88.1 FM", category: "Religiosa",
    image: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20serene%20cover%20art%2C%20warm%20sunrise%20with%20dove%20silhouette%2C%20soft%20peaceful%20golden%20lighting%20atmosphere&width=400&height=300&seq=tv-radio-fe&orientation=landscape",
    isLive: false, currentProgram: "Mañanas de Bendición", listeners: 1890,
  },
  {
    id: 8, name: "Radio Vida Nueva", frequency: "93.7 FM", category: "Religiosa",
    image: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20peaceful%20cover%20art%2C%20cross%20silhouette%20with%20sunrise%2C%20soft%20blue%20and%20white%20spiritual%20tones&width=400&height=300&seq=tv-radio-vida&orientation=landscape",
    isLive: false, currentProgram: "Noche de Alabanza", listeners: 1560,
  },
];

export const tvPrograms: TvProgram[] = [
  { id: 1, name: "El Sabor del Mediodía", host: "Alejandro Ramírez", radioName: "La Mexicana FM", image: "https://readdy.ai/api/search-image?query=Latin%20food%20and%20music%20radio%20show%20cover%20art%2C%20warm%20kitchen%20studio%20with%20festive%20atmosphere%2C%20rich%20orange%20and%20terracotta%20tones&width=400&height=225&seq=tv-prog-sabor&orientation=landscape", isLive: true, time: "12:00 - 14:00", category: "Regional" },
  { id: 2, name: "Rock Total en Vivo", host: "Andrés Castillo", radioName: "Rock Total Radio", image: "https://readdy.ai/api/search-image?query=Rock%20concert%20radio%20show%20cover%20art%2C%20electric%20guitars%20and%20concert%20stage%20lights%2C%20dramatic%20red%20and%20blue%20atmosphere&width=400&height=225&seq=tv-prog-rock&orientation=landscape", isLive: true, time: "18:00 - 21:00", category: "Música" },
  { id: 3, name: "Carrusel Deportivo", host: "Javier Solís", radioName: "Deportes Total Radio", image: "https://readdy.ai/api/search-image?query=Sports%20commentary%20radio%20show%20cover%20art%2C%20stadium%20panorama%20with%20commentator%20desk%2C%20dynamic%20blue%20and%20gold%20energy&width=400&height=225&seq=tv-prog-deportes&orientation=landscape", isLive: true, time: "17:00 - 20:00", category: "Deportes" },
  { id: 4, name: "Tardes de Actitud", host: "Natalia Campos", radioName: "Radio Nueva Actitud", image: "https://readdy.ai/api/search-image?query=Positive%20lifestyle%20radio%20show%20cover%20art%2C%20bright%20sunny%20studio%20with%20plants%2C%20warm%20and%20uplifting%20golden%20atmosphere&width=400&height=225&seq=tv-prog-actitud&orientation=landscape", isLive: true, time: "14:00 - 17:00", category: "Entretenimiento" },
  { id: 5, name: "Mañanas de Bendición", host: "Pastor Daniel", radioName: "Radio Fe y Esperanza", image: "https://readdy.ai/api/search-image?query=Morning%20Christian%20radio%20show%20cover%20art%2C%20sunrise%20over%20hills%20with%20peaceful%20chapel%2C%20warm%20golden%20spiritual%20light&width=400&height=225&seq=tv-prog-bendicion&orientation=landscape", isLive: false, time: "07:00 - 10:00", category: "Religiosa" },
  { id: 6, name: "Tardes de Pop", host: "Diego Montenegro", radioName: "La Kalle 99.9", image: "https://readdy.ai/api/search-image?query=Colorful%20pop%20music%20radio%20show%20cover%20art%2C%20neon%20lit%20studio%20with%20DJ%20equipment%2C%20vibrant%20pink%20and%20coral%20energy&width=400&height=225&seq=tv-prog-pop&orientation=landscape", isLive: true, time: "15:00 - 18:00", category: "Música" },
];

export const tvEvents: TvEvent[] = [
  { id: 1, title: "Summer Fest 2026", radioName: "Radio Nueva Actitud", date: "2026-07-15", image: "https://readdy.ai/api/search-image?query=Summer%20music%20festival%20outdoor%20stage%20cover%20art%2C%20concert%20crowd%20at%20sunset%2C%20warm%20festive%20atmosphere%20with%20bright%20lights&width=400&height=225&seq=tv-event-summer&orientation=landscape", type: "Festival" },
  { id: 2, title: "Concierto Sinfónico", radioName: "Radio Vida Nueva", date: "2026-07-22", image: "https://readdy.ai/api/search-image?query=Classical%20orchestra%20concert%20hall%20cover%20art%2C%20musicians%20on%20stage%20with%20dramatic%20lighting%2C%20elegant%20cultural%20atmosphere&width=400&height=225&seq=tv-event-sinfonico&orientation=landscape", type: "Concierto" },
  { id: 3, title: "Noche de Alabanza", radioName: "Radio Fe y Esperanza", date: "2026-06-28", image: "https://readdy.ai/api/search-image?query=Christian%20worship%20night%20event%20cover%20art%2C%20people%20praising%20with%20raised%20hands%2C%20warm%20spiritual%20lighting%20atmosphere&width=400&height=225&seq=tv-event-alabanza&orientation=landscape", type: "Religioso" },
  { id: 4, title: "Trivia Musical Final", radioName: "Deportes Total Radio", date: "2026-07-08", image: "https://readdy.ai/api/search-image?query=Music%20trivia%20game%20show%20cover%20art%2C%20quiz%20show%20stage%20with%20colorful%20lights%2C%20exciting%20competition%20atmosphere&width=400&height=225&seq=tv-event-trivia&orientation=landscape", type: "Concurso" },
];

export const tvStats = {
  totalStations: 82,
  liveNow: 24,
  totalPrograms: 156,
  totalEvents: 31,
  totalListeners: 42780,
};

export const tvPlatforms = [
  { name: "Android TV", icon: "ri-android-line", color: "text-emerald-500", bg: "bg-emerald-500/10" },
  { name: "Fire TV", icon: "ri-fire-fill", color: "text-orange-500", bg: "bg-orange-500/10" },
  { name: "Samsung TV", icon: "ri-tv-line", color: "text-sky-500", bg: "bg-sky-500/10" },
  { name: "LG TV", icon: "ri-tv-2-line", color: "text-rose-500", bg: "bg-rose-500/10" },
];

export interface TvRadioHost {
  name: string;
  avatar: string;
  role: string;
}

export interface TvPlayerRadio {
  id: number;
  name: string;
  frequency: string;
  category: string;
  logo: string;
  cover: string;
  currentProgram: string;
  host: TvRadioHost;
  listeners: number;
  uptime: string;
  isLive: boolean;
  description: string;
}

export const tvPlayerRadios: TvPlayerRadio[] = [
  {
    id: 1,
    name: "La Mexicana FM",
    frequency: "98.7 FM",
    category: "Regional",
    logo: "https://readdy.ai/api/search-image?query=Mexican%20radio%20station%20square%20logo%20design%2C%20sombrero%20and%20guitar%20icon%2C%20warm%20orange%20and%20green%20emblem%2C%20clean%20flat%20vector%20style&width=200&height=200&seq=tv-player-logo-mexicana&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Mexican%20regional%20music%20atmosphere%2C%20warm%20festive%20colorful%20background%20with%20papel%20picado%20banners%2C%20acoustic%20guitar%2C%20mariachi%20trumpet%2C%20soft%20bokeh%20lights%2C%20rich%20orange%20amber%20and%20green%20tones%2C%20concert%20stage%20blur%20background&width=1280&height=720&seq=tv-player-cover-mexicana&orientation=landscape",
    currentProgram: "El Sabor del Mediodía",
    host: { name: "Alejandro Ramírez", avatar: "https://readdy.ai/api/search-image?query=Mexican%20male%20radio%20host%20portrait%2C%20friendly%20warm%20smile%2C%20casual%20professional%2C%20broadcast%20studio%20background%2C%20natural%20lighting&width=120&height=120&seq=tv-player-host-mexicana&orientation=squarish", role: "Locutor Principal" },
    listeners: 4231,
    uptime: "3h 42m",
    isLive: true,
    description: "La mejor música regional mexicana las 24 horas. Banda, norteño, mariachi y mucho más.",
  },
  {
    id: 2,
    name: "Rock Total Radio",
    frequency: "95.3 FM",
    category: "Música",
    logo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20square%20logo%2C%20electric%20guitar%20silhouette%2C%20bold%20red%20and%20black%20emblem%2C%20grunge%20style%20flat%20vector&width=200&height=200&seq=tv-player-logo-rock&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Rock%20concert%20stage%20with%20dramatic%20red%20and%20dark%20lighting%2C%20electric%20guitars%20on%20stands%2C%20amplifier%20stacks%2C%20smoke%20atmosphere%2C%20energetic%20concert%20vibe%2C%20crowd%20silhouettes&width=1280&height=720&seq=tv-player-cover-rock&orientation=landscape",
    currentProgram: "Rock Total en Vivo",
    host: { name: "Andrés Castillo", avatar: "https://readdy.ai/api/search-image?query=Rock%20radio%20host%20male%20portrait%2C%20leather%20jacket%2C%20confident%20expression%2C%20studio%20with%20guitars%20on%20wall%2C%20edgy%20lighting&width=120&height=120&seq=tv-player-host-rock&orientation=squarish", role: "Locutor" },
    listeners: 2890,
    uptime: "2h 15m",
    isLive: true,
    description: "Rock clásico, alternativo y los mejores clásicos de todos los tiempos. Sin pausa.",
  },
  {
    id: 3,
    name: "Radio Nueva Actitud",
    frequency: "102.5 FM",
    category: "Música",
    logo: "https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20square%20logo%2C%20minimalist%20sunburst%20icon%2C%20warm%20golden%20and%20coral%20emblem%2C%20clean%20elegant%20vector&width=200&height=200&seq=tv-player-logo-actitud&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Warm%20modern%20radio%20studio%20atmosphere%20with%20golden%20hour%20lighting%2C%20sleek%20broadcast%20equipment%2C%20cozy%20plant%20decor%2C%20soft%20bokeh%2C%20positive%20uplifting%20warm%20tones&width=1280&height=720&seq=tv-player-cover-actitud&orientation=landscape",
    currentProgram: "Tardes de Actitud",
    host: { name: "Natalia Campos", avatar: "https://readdy.ai/api/search-image?query=Female%20radio%20host%20portrait%2C%20warm%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20plants%2C%20natural%20golden%20lighting&width=120&height=120&seq=tv-player-host-actitud&orientation=squarish", role: "Locutora" },
    listeners: 3150,
    uptime: "4h 08m",
    isLive: true,
    description: "Actitud positiva, buena música y las mejores vibras para tu día.",
  },
  {
    id: 4,
    name: "Deportes Total Radio",
    frequency: "101.1 FM",
    category: "Deportes",
    logo: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20square%20logo%2C%20soccer%20ball%20and%20microphone%20icon%2C%20bold%20blue%20and%20gold%20emblem%2C%20dynamic%20flat%20vector%20style&width=200&height=200&seq=tv-player-logo-deportes&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Sports%20broadcast%20studio%20with%20stadium%20panorama%20view%2C%20commentator%20desk%20with%20microphones%2C%20dynamic%20blue%20and%20gold%20lighting%2C%20soccer%20field%20visible%20through%20window&width=1280&height=720&seq=tv-player-cover-deportes&orientation=landscape",
    currentProgram: "Carrusel Deportivo",
    host: { name: "Javier Solís", avatar: "https://readdy.ai/api/search-image?query=Male%20sports%20commentator%20portrait%2C%20professional%20headset%2C%20enthusiastic%20expression%2C%20broadcast%20booth%2C%20blue%20lighting&width=120&height=120&seq=tv-player-host-deportes&orientation=squarish", role: "Comentarista" },
    listeners: 5210,
    uptime: "1h 53m",
    isLive: true,
    description: "La casa del deporte. Fútbol, béisbol, básquet y toda la acción deportiva en vivo.",
  },
  {
    id: 5,
    name: "La Kalle 99.9",
    frequency: "99.9 FM",
    category: "Música",
    logo: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=200&height=200&seq=tv-player-logo-kalle&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20neon%20lit%20radio%20studio%2C%20DJ%20equipment%20with%20LED%20lights%2C%20vibrant%20pink%20coral%20and%20purple%20atmosphere%2C%20modern%20energetic%20pop%20vibe%2C%20party%20energy&width=1280&height=720&seq=tv-player-cover-kalle&orientation=landscape",
    currentProgram: "Tardes de Pop",
    host: { name: "Diego Montenegro", avatar: "https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20energetic%20smile%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=120&height=120&seq=tv-player-host-kalle&orientation=squarish", role: "DJ / Locutor" },
    listeners: 2780,
    uptime: "5h 21m",
    isLive: true,
    description: "Pop, hits del momento y la mejor energía para tus tardes.",
  },
  {
    id: 6,
    name: "Banda Radio MX",
    frequency: "107.9 FM",
    category: "Regional",
    logo: "https://readdy.ai/api/search-image?query=Mexican%20banda%20radio%20station%20square%20logo%2C%20trumpet%20and%20drum%20icon%2C%20bold%20red%20green%20white%20emblem%2C%20festive%20flat%20vector%20style&width=200&height=200&seq=tv-player-logo-banda&orientation=squarish",
    cover: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20festive%20atmosphere%2C%20traditional%20brass%20instruments%2C%20colorful%20papel%20picado%2C%20warm%20stage%20lighting%2C%20celebration%20vibe%2C%20rich%20cultural%20colors&width=1280&height=720&seq=tv-player-cover-banda&orientation=landscape",
    currentProgram: "Tardes de Banda",
    host: { name: "Carlos Mendoza", avatar: "https://readdy.ai/api/search-image?query=Mexican%20male%20radio%20host%20portrait%2C%20traditional%20style%2C%20warm%20smile%2C%20festive%20studio%20background%2C%20natural%20lighting&width=120&height=120&seq=tv-player-host-banda&orientation=squarish", role: "Locutor" },
    listeners: 3650,
    uptime: "2h 37m",
    isLive: true,
    description: "Pura banda, norteño y lo mejor de la música regional mexicana.",
  },
];

// Dedicated RFW TV fallback identity — never use tvPlayerRadios[0] as fallback
export const rfwTvRadio: TvPlayerRadio = {
  id: 0,
  name: "RFW TV",
  frequency: "RadioFrecuenciaWeb",
  category: "Plataforma",
  logo: "https://readdy.ai/api/search-image?query=RFW%20RadioFrecuenciaWeb%20TV%20brand%20logo%2C%20modern%20minimalist%20broadcast%20icon%2C%20warm%20orange%20to%20rose%20gradient%2C%20clean%20square%20design%2C%20professional%20media%20network%20identity&width=400&height=400&seq=tv-rfw-logo&orientation=squarish",
  cover: "https://readdy.ai/api/search-image?query=Modern%20TV%20broadcast%20control%20room%20with%20warm%20ambient%20lighting%2C%20professional%20video%20production%20monitors%20displaying%20colorful%20waveforms%2C%20sleek%20dark%20studio%20with%20orange%20and%20warm%20accent%20lights%2C%20cinematic%20broadcast%20atmosphere%2C%20high%20end%20production%20facility&width=1400&height=788&seq=tv-rfw-cover&orientation=landscape",
  currentProgram: "RFW TV · 24/7",
  host: { name: "RFW Network", avatar: "https://readdy.ai/api/search-image?query=RFW%20RadioFrecuenciaWeb%20brand%20icon%20avatar%2C%20warm%20orange%20and%20rose%20gradient%20circle%2C%20modern%20minimalist%20broadcast%20symbol%2C%20clean%20professional%20identity&width=200&height=200&seq=tv-rfw-host&orientation=squarish", role: "Plataforma Oficial" },
  listeners: 0,
  uptime: "24/7",
  isLive: true,
  description: "Bienvenido a RFW TV, el canal oficial de RadioFrecuenciaWeb. Disfrutá de contenido exclusivo, radios destacadas, programas, eventos y mucho más. Siempre al aire, siempre con vos.",
};

export const tvQrInfo = {
  qrImage: "https://readdy.ai/api/search-image?query=Modern%20QR%20code%20design%20with%20radio%20wave%20pattern%20integrated%2C%20clean%20black%20and%20white%2C%20high%20contrast%2C%20minimalist%20tech%20aesthetic%2C%20square%20format&width=512&height=512&seq=tv-qr-link&orientation=squarish",
  pairingCode: "RFW-TV-8429",
  instructions: "Abrí la app de RadioFrecuenciaWeb en tu celular, andá a Configuración > Vincular TV e ingresá el código o escaneá el QR.",
  expiresIn: "5:00",
};

// ── TV Pairing Session Mock ──
export type TvPairingState = 'WAITING' | 'CONNECTED_MOCK' | 'EXPIRED' | 'DISCONNECTED' | 'ERROR';

export interface TvPairingSession {
  state: TvPairingState;
  pairingCode: string;
  deviceName: string;
  connectedAt: number | null;
  expiresAt: number;
  sessionId: string;
}

export function generatePairingCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = 'RFW-TV-';
  for (let i = 0; i < 4; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export function createPairingSession(): TvPairingSession {
  return {
    state: 'WAITING',
    pairingCode: generatePairingCode(),
    deviceName: 'RFW TV Living Room',
    connectedAt: null,
    expiresAt: Date.now() + 5 * 60 * 1000, // 5 min
    sessionId: `tv-session-${Date.now()}`,
  };
}

export const pairingCodeCharset = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';